import React from "react";
import HomePage from "../pages/osportwears/home_page";
import AppRoutes from "../routes";
const OSportWearsTemplate = () => {
  return (
    <React.Fragment>
      <div className="flex flex-col min-h-screen">
        {/* <Header /> */}
        <AppRoutes homePage={HomePage} />
        <div className="mt-auto">{/* <Footer /> */}</div>
      </div>
    </React.Fragment>
  );
};

export default OSportWearsTemplate;
